import { render, staticRenderFns } from "./PopupPreloader.vue?vue&type=template&id=3dd60510&"
import script from "./PopupPreloader.vue?vue&type=script&lang=js&"
export * from "./PopupPreloader.vue?vue&type=script&lang=js&"
import style0 from "./PopupPreloader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports